import { dialog } from "../../../../../nq-component";
import React from "react";

function DialogAssign({ handleAssign, change, recruiter }) {
  const onClickOk = () => {
    dialog.close();
  };
  return (
    <>
      <div className="d-flex">
        <div className="m-4">
          <i
            class="bi bi-person-check fs-2 p-2 rounded-1"
            style={{
              backgroundColor: "#e8ecf3",
              color: "#D18237",
            }}
          ></i>
        </div>
        <div className="ms-3 me-3" style={{ marginTop: "35px" }}>
          <h5 className="fw-bold" style={{ color: "#D18237" }}>
            Assign Applicant
          </h5>
          <p>
            {change === true
              ? "This applicant will be assigned to you. Please see it in your My Listing module."
              : change === "alreadyClaimed"
              ? `${
                  recruiter || "A recruiter"
                } has already taken this applicant.`
              : "Are you sure you want this applicant to be assign to you?"}
          </p>
        </div>
      </div>
      <div className="text-center mb-3">
        <>
          {change === true || change === "alreadyClaimed" ? (
            <button
              className="btn text-white ms-2"
              style={{ backgroundColor: "#D18237" }}
              onClick={onClickOk}
            >
              Close
            </button>
          ) : (
            <>
              <button
                className="btn"
                style={{ backgroundColor: "#e8ecf3" }}
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                className="btn text-white ms-2"
                style={{ backgroundColor: "#D18237" }}
                onClick={() => handleAssign()}
              >
                Confirm
              </button>
            </>
          )}
        </>
      </div>
    </>
  );
}

export default DialogAssign;
